export default "__VITE_ASSET__DrEC62cC__"